import { withLoginEnforced } from '@/shared/auth/oidc';
import type { PermissionId } from '@/shared/auth/permissions';
import { useUserHasSomePermissions } from '@/shared/auth/useUserAffectations';
import { Alert, Box } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

type Props = {
  requiredPermissions: PermissionId | PermissionId[];
  children: React.ReactNode;
};

const PermissionGate = ({ requiredPermissions, children }: Props) => {
  const { t } = useTranslate();
  const permissions = Array.isArray(requiredPermissions)
    ? requiredPermissions
    : [requiredPermissions];
  const { result: hasPermission, isLoading } = useUserHasSomePermissions(permissions);

  if (isLoading) {
    return null;
  }

  if (!hasPermission) {
    return (
      <Box maw={400} mx="auto" mt="xl">
        <Alert
          variant="light"
          color="yellow"
          title={t('permission.notfound.title')}
          icon={<IconAlertTriangle />}
        >
          {t('permission.notfound.content')}
        </Alert>
      </Box>
    );
  }

  return <>{children}</>;
};

export default withLoginEnforced(PermissionGate);
